import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import * as stngs from '~js/utils/settings';
import { loadScript } from '~js/utils/utils';
import { a11y } from '~js/components/a11y';
import { LoadQuickview } from '~js/components/load-quickview';
import { LoadVideoVimeo } from '~js/components/load-vimeo-video';
import { LoadVideoYT } from '~js/components/load-youtube-video';
import { LoadNotification } from '~js/components/load-notification';

const loaderHTML = `<div class="${c.classes$B.loader}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;


export class LoadPhotoswipe {
  constructor(items, options = '', templateIndex = 0, triggerButton = null) {
    this.items = items;
    this.triggerBtn = triggerButton;
    this.pswpElements = document.querySelectorAll(s.selectors$L.popupContainer);
    this.pswpElement = this.pswpElements[templateIndex];
    this.popup = null;
    this.popupThumbs = null;
    this.popupThumbsContainer = this.pswpElement.querySelector(s.selectors$L.popupThumbs);
    this.closeBtn = this.pswpElement.querySelector(s.selectors$L.popupCloseBtn);
    const defaultOptions = {
      history: false,
      focus: false,
      mainClass: '',
    };
    this.options = options !== '' ? options : defaultOptions;
    this.onCloseCallback = () => this.onClose();
    this.dispatchPopupInitEventCallback = () => this.dispatchPopupInitEvent();
    this.setCurrentThumbCallback = () => this.setCurrentThumb();
    this.a11y = a11y;

    this.init();
  }

  init() {
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));

    this.pswpElement.classList.add(c.classes$B.customOpen);

    this.initLoader();

    loadScript({ url: window.theme.assets.photoswipe })
      .then(() => this.loadPopup())
      .catch((e) => console.error(e));
  }

  initLoader() {
    if (
      this.pswpElement.classList.contains(c.classes$B.customLoader) &&
      this.options !== '' &&
      this.options.mainClass
    ) {
      this.pswpElement.setAttribute(a.attributes$u.dataOptionClasses, this.options.mainClass);
      let loaderElem = document.createElement('div');
      loaderElem.innerHTML = loaderHTML;
      loaderElem = loaderElem.firstChild;
      this.pswpElement.appendChild(loaderElem);
    } else {
      this.pswpElement.setAttribute(a.attributes$u.dataOptionClasses, '');
    }
  }

  loadPopup() {
    const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
    const PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;

    if (this.pswpElement.classList.contains(c.classes$B.customLoader)) {
      this.pswpElement.classList.remove(c.classes$B.customLoader);
    }

    this.pswpElement.classList.remove(c.classes$B.customOpen);

    this.popup = new PhotoSwipe(this.pswpElement, PhotoSwipeUI, this.items, this.options);

    this.popup.listen('afterInit', this.dispatchPopupInitEventCallback);
    this.popup.listen('imageLoadComplete', this.setCurrentThumbCallback);
    this.popup.listen('beforeChange', this.setCurrentThumbCallback);
    this.popup.listen('close', this.onCloseCallback);

    this.popup.init();

    this.initPopupCallback();
  }

  initPopupCallback() {
    if (this.isVideo) {
      this.hideUnusedButtons();
    }

    this.initVideo();
    this.thumbsActions();

    this.a11y.trapFocus({
      container: this.pswpElement,
    });

    if (this.pswpElement.classList.contains(c.classes$B.quickviewPopup)) {
      new LoadQuickview(this.popup, this.pswpElement);
    }

    if (this.pswpElement.classList.contains(c.classes$B.notificationPopup)) {
      new LoadNotification(this.popup, this.pswpElement);
    }

    if (this.triggerBtn && this.triggerBtn.hasAttribute('data-upsell-quick-view')) {

      this.mainAddToCartBtn = document.querySelector('.product-single__details .product__block.product__form__wrapper form [data-add-to-cart]');

      this.quickViewAddToCart = this.pswpElement.querySelector(s.selectors$O.addToCart);

      if (this.mainAddToCartBtn && !this.mainAddToCartBtn.hasAttribute('data-current-variant-unavailable') && this.quickViewAddToCart) {

        this.quickViewAddToCart.setAttribute('data-add-both-to-cart', '');

        const quickViewAddToCartText = this.quickViewAddToCart.querySelector(s.selectors$O.addToCartText);
        if (quickViewAddToCartText) {
          if (!this.quickViewAddToCart.hasAttribute('data-current-variant-unavailable')) {
            quickViewAddToCartText.textContent = window.theme.strings.add_both_to_cart;
          }
          quickViewAddToCartText.setAttribute('data-add-both-to-cart-text', '');
        }
      }

    }

    this.closePopup = () => {

      console.log('close Button clicked');

      if (this.pswpElement.classList.contains(c.classes$B.quickviewPopup)) {
        this.pswpElement.classList.add(c.classes$B.quickViewAnimateOut);
      } else {
        this.popup.close();
      }
    };

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.closePopup);
    }

    // Close Quick view popup when product added to cart
    document.addEventListener('theme:cart:added', this.closePopup);
  }

  dispatchPopupInitEvent() {
    if (this.triggerBtn) {
      this.triggerBtn.dispatchEvent(new CustomEvent('theme:popup:init', { bubbles: true }));
    }
  }

  initVideo() {
    const videoContainer = this.pswpElement.querySelector(s.selectors$L.popupCustomIframe);
    if (videoContainer) {
      const videoType = videoContainer.getAttribute(a.attributes$u.dataVideoType);
      this.isVideo = true;

      if (videoType == 'youtube') {
        new LoadVideoYT(videoContainer.parentElement);
      } else if (videoType == 'vimeo') {
        new LoadVideoVimeo(videoContainer.parentElement);
      }
    }
  }

  thumbsActions() {
    if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) {
      this.popupThumbsContainer.addEventListener('wheel', (e) => this.stopDisabledScroll(e));
      this.popupThumbsContainer.addEventListener('mousewheel', (e) => this.stopDisabledScroll(e));
      this.popupThumbsContainer.addEventListener('DOMMouseScroll', (e) => this.stopDisabledScroll(e));

      this.popupThumbs = this.pswpElement.querySelectorAll(`${s.selectors$L.popupThumbs} > *`);
      this.popupThumbs.forEach((element, i) => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          element.parentElement.querySelector(`.${c.classes$B.current}`).classList.remove(c.classes$B.current);
          element.classList.add(c.classes$B.current);
          this.popup.goTo(i);
        });
      });
    }
  }

  hideUnusedButtons() {
    const buttons = this.pswpElement.querySelectorAll(s.selectors$L.popupButtons);
    buttons.forEach((element) => {
      if (!element.classList.contains(c.classes$B.popupCloseButton)) {
        element.style.display = 'none';
      }
    });
  }

  stopDisabledScroll(e) {
    e.stopPropagation();
  }

  onClose() {
    const popupIframe = this.pswpElement.querySelector(s.selectors$L.popupIframe);
    if (popupIframe) {
      popupIframe.parentNode.removeChild(popupIframe);
    }

    if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) {
      while (this.popupThumbsContainer.firstChild) {
        this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
      }
    }

    this.pswpElement.setAttribute(a.attributes$u.dataOptionClasses, '');
    const loaderElem = this.pswpElement.querySelector(`.${c.classes$B.loader}`);
    if (loaderElem) {
      this.pswpElement.removeChild(loaderElem);
    }

    if (!document.body.classList.contains(c.classes$B.isCartDrawerOpen)) {
      this.a11y.removeTrapFocus();
    }

    document.removeEventListener('theme:cart:added', this.closePopup);

    // Unlock scroll if only cart drawer is closed and there are no more popups opened
    setTimeout(() => {
      const recentlyOpenedPopups = this.recentlyOpenedPopupsCount();
      const isCartDrawerOpen = document.body.classList.contains(c.classes$B.isCartDrawerOpen);

      if (recentlyOpenedPopups === 0 && !isCartDrawerOpen) {
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      }
    }, stngs.settings$6.unlockScrollDelay);
  }

  recentlyOpenedPopupsCount() {
    let count = 0;

    this.pswpElements.forEach((popup) => {
      const isOpened = popup.classList.contains(c.classes$B.opened);

      if (isOpened) {
        count += 1;
      }
    });

    return count;
  }

  setCurrentThumb() {
    const hasThumbnails = this.popupThumbsContainer && this.popupThumbsContainer.firstChild;

    if (hasThumbnails) return;

    const lastCurrentThumb = this.pswpElement.querySelector(`${s.selectors$L.popupThumbs} > .${c.classes$B.current}`);
    if (lastCurrentThumb) {
      lastCurrentThumb.classList.remove(c.classes$B.current);
    }

    if (!this.popupThumbs) {
      return;
    }
    const currentThumb = this.popupThumbs[this.popup.getCurrentIndex()];
    currentThumb.classList.add(c.classes$B.current);
    this.scrollThumbs(currentThumb);
  }

  scrollThumbs(currentThumb) {
    const thumbsContainerLeft = this.popupThumbsContainer.scrollLeft;
    const thumbsContainerWidth = this.popupThumbsContainer.offsetWidth;
    const thumbsContainerPos = thumbsContainerLeft + thumbsContainerWidth;
    const currentThumbLeft = currentThumb.offsetLeft;
    const currentThumbWidth = currentThumb.offsetWidth;
    const currentThumbPos = currentThumbLeft + currentThumbWidth;

    if (thumbsContainerPos <= currentThumbPos || thumbsContainerPos > currentThumbLeft) {
      const currentThumbMarginLeft = parseInt(window.getComputedStyle(currentThumb).marginLeft);
      this.popupThumbsContainer.scrollTo({
        top: 0,
        left: currentThumbLeft - currentThumbMarginLeft,
        behavior: 'smooth',
      });
    }
  }
}